module.exports = __webpack_public_path__ + "media/images/brands/marque-peggy-sage@3x-2161268c3a1d42ce0f72f682412fa4a4.jpg";